import { Component, inject, input, output } from '@angular/core';
import { MasterDataStore } from '../services/master-data.store';
import { UrlConstants } from './../../pages/common/constants/url.constants';
import { openInNewTab } from './../../pages/common/utils/navigate-to';
@Component({
  selector: 'app-page-header',
  standalone: true,
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  /** マスタデータストア（アプリ起動時に一度だけロードする） */
  private readonly masterDataStore = inject(MasterDataStore);

  /**
   * ロゴクリック時にオフィシャルHPを同一画面で表示
   */
  openOfficialSite(): void {
    openInNewTab(this.masterDataStore.getTransitionDestinationUrl(UrlConstants.COMPANY_ICON_URL) ?? 'https://www.dai-ichi-life.co.jp/');
  }
  /** ハンバーガーメニューの開閉状態 */
  readonly isMenuOpen = input(false);

  /** ハンバーガーアイコン押下イベント */
  menuOpen = output<void>();

  /** メニューを閉じる */
  menuClose = output<void>();

  /** FAQリンク押下イベント（PCヘッダー） */
  faqClick = output<void>();

  /** ウィンドウを閉じる押下イベント（PCヘッダー） */
  closeWindowClick = output<void>();

  onMenuIconClick(): void {
    if (this.isMenuOpen()) {
      this.menuClose.emit();
      return;
    }
    this.menuOpen.emit();
  }

  onFaqClick(): void {
    this.faqClick.emit();
  }

  onCloseWindowClick(): void {
    this.closeWindowClick.emit();
  }
}
